// values from Icon.tokens.scss in @pexip/components
export const MEDIUM_ICON_SIZE = '32px';
export const SMALL_ICON_SIZE = '24px';
export const COMPACT_ICON_SIZE = '16px';
